/**
 * 資産カテゴリ定義
 */
export const assetCategories = [
  { title: '現金', items: [
    { id: 'cash', placeholder: '例: 500' }
  ]},
  { title: '家屋', items: [
    { id: 'house_own', label: '自宅', placeholder: '例: 3000' },
    { id: 'house_rental', label: '貸付事業用', placeholder: '例: 2000' },
    { id: 'house_other', label: 'その他', placeholder: '例: 1000' }
  ]},
  { title: '土地', items: [
    { id: 'land_business', label: '自社事業用', placeholder: '例: 5000' },
    { id: 'land_rental', label: '貸付事業用', placeholder: '例: 4000' },
    { id: 'land_other', label: 'その他', placeholder: '例: 3000' }
  ]},
  { title: '有価証券', items: [
    { id: 'securities_company', label: '自社株', placeholder: '例: 2000' },
    { id: 'securities_public', label: '上場株', placeholder: '例: 1000' },
    { id: 'securities_trust', label: '投資信託', placeholder: '例: 500' },
    { id: 'securities_other', label: 'その他', placeholder: '例: 300' }
  ]},
  { title: '家庭用財産（家具・美術品・貴金属等）', items: [
    { id: 'household', placeholder: '例: 200' }
  ]},
  { title: '保険金', items: [
    { id: 'insurance', placeholder: '例: 1000', note: '死亡保険金額を入力' }
  ]},
  { title: '退職金', items: [
    { id: 'retirement', placeholder: '例: 1500' }
  ]},
  { title: 'その他（ゴルフ会員権・貸付金・特許権など）', items: [
    { id: 'other', placeholder: '例: 500' }
  ]},
  { title: '被相続人から3年以内の贈与', items: [
    { id: 'gift', placeholder: '例: 100' }
  ]},
  { title: '借金（借入金・葬儀費用など）', items: [
    { id: 'debt', placeholder: '例: 500' }
  ]}
];
